export default __webpack_public_path__ + "static/Knoxville_AdobeStock_307020613-0a166e207ff33f4ee360e26134992d47.jpeg";